/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiSearchFilter } from './InternalApiSearchFilter';
import {
    InternalApiSearchFilterFromJSON,
    InternalApiSearchFilterFromJSONTyped,
    InternalApiSearchFilterToJSON,
    InternalApiSearchFilterToJSONTyped,
} from './InternalApiSearchFilter';
import type { InternalApiLogicalOperator } from './InternalApiLogicalOperator';
import {
    InternalApiLogicalOperatorFromJSON,
    InternalApiLogicalOperatorFromJSONTyped,
    InternalApiLogicalOperatorToJSON,
    InternalApiLogicalOperatorToJSONTyped,
} from './InternalApiLogicalOperator';
import type { InternalApiExportFileType } from './InternalApiExportFileType';
import {
    InternalApiExportFileTypeFromJSON,
    InternalApiExportFileTypeFromJSONTyped,
    InternalApiExportFileTypeToJSON,
    InternalApiExportFileTypeToJSONTyped,
} from './InternalApiExportFileType';
import type { InternalApiSortDirection } from './InternalApiSortDirection';
import {
    InternalApiSortDirectionFromJSON,
    InternalApiSortDirectionFromJSONTyped,
    InternalApiSortDirectionToJSON,
    InternalApiSortDirectionToJSONTyped,
} from './InternalApiSortDirection';

/**
 * 
 * @export
 * @interface InternalApiTransactionExportQuery
 */
export interface InternalApiTransactionExportQuery {
    /**
     * 
     * @type {string}
     * @memberof InternalApiTransactionExportQuery
     */
    orderBy?: string;
    /**
     * 
     * @type {InternalApiSortDirection}
     * @memberof InternalApiTransactionExportQuery
     */
    direction?: InternalApiSortDirection;
    /**
     * 
     * @type {Array<InternalApiSearchFilter>}
     * @memberof InternalApiTransactionExportQuery
     */
    filters: Array<InternalApiSearchFilter>;
    /**
     * 
     * @type {InternalApiLogicalOperator}
     * @memberof InternalApiTransactionExportQuery
     */
    logicalOperator: InternalApiLogicalOperator;
    /**
     * 
     * @type {InternalApiExportFileType}
     * @memberof InternalApiTransactionExportQuery
     */
    fileType: InternalApiExportFileType;
}



/**
 * Check if a given object implements the InternalApiTransactionExportQuery interface.
 */
export function instanceOfInternalApiTransactionExportQuery(value: object): value is InternalApiTransactionExportQuery {
    if (!('filters' in value) || value['filters'] === undefined) return false;
    if (!('logicalOperator' in value) || value['logicalOperator'] === undefined) return false;
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    return true;
}

export function InternalApiTransactionExportQueryFromJSON(json: any): InternalApiTransactionExportQuery {
    return InternalApiTransactionExportQueryFromJSONTyped(json, false);
}

export function InternalApiTransactionExportQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransactionExportQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'orderBy': json['orderBy'] == null ? undefined : json['orderBy'],
        'direction': json['direction'] == null ? undefined : InternalApiSortDirectionFromJSON(json['direction']),
        'filters': ((json['filters'] as Array<any>).map(InternalApiSearchFilterFromJSON)),
        'logicalOperator': InternalApiLogicalOperatorFromJSON(json['logicalOperator']),
        'fileType': InternalApiExportFileTypeFromJSON(json['fileType']),
    };
}

export function InternalApiTransactionExportQueryToJSON(json: any): InternalApiTransactionExportQuery {
    return InternalApiTransactionExportQueryToJSONTyped(json, false);
}

export function InternalApiTransactionExportQueryToJSONTyped(value?: InternalApiTransactionExportQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderBy': value['orderBy'],
        'direction': InternalApiSortDirectionToJSON(value['direction']),
        'filters': ((value['filters'] as Array<any>).map(InternalApiSearchFilterToJSON)),
        'logicalOperator': InternalApiLogicalOperatorToJSON(value['logicalOperator']),
        'fileType': InternalApiExportFileTypeToJSON(value['fileType']),
    };
}

